var map = {
	"./de-de.json": [
		"./src/assets/i18n/de-de.json",
		0
	],
	"./en-au.json": [
		"./src/assets/i18n/en-au.json",
		1
	],
	"./en-in.json": [
		"./src/assets/i18n/en-in.json",
		2
	],
	"./en-us.json": [
		"./src/assets/i18n/en-us.json",
		3
	],
	"./es-es.json": [
		"./src/assets/i18n/es-es.json",
		4
	],
	"./es-mx.json": [
		"./src/assets/i18n/es-mx.json",
		5
	],
	"./es-pr.json": [
		"./src/assets/i18n/es-pr.json",
		6
	],
	"./fr-be.json": [
		"./src/assets/i18n/fr-be.json",
		7
	],
	"./fr-fr.json": [
		"./src/assets/i18n/fr-fr.json",
		8
	],
	"./it-it.json": [
		"./src/assets/i18n/it-it.json",
		9
	],
	"./nl-be.json": [
		"./src/assets/i18n/nl-be.json",
		10
	],
	"./nl-nl.json": [
		"./src/assets/i18n/nl-nl.json",
		11
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/assets/i18n lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;